import { ReactElement } from "react";
import { CanProps, Can as CaslCan } from "@casl/react";

import { Ability } from "../../models/permissions";

// CASL 7 types Can as returning ReactNode, which TypeScript < 5.1 rejects as a JSX component.
export const Can = CaslCan as (props: CanProps<Ability>) => ReactElement | null;
